import React, { useContext } from 'react';

import { FccSection, SelectTeam } from 'components';
import MatchInfoSummary from './MatchInfoSummary';

import { ManualImportMatchContext } from '../../ManualImportMatch';

import { reducerActions } from 'pages/CreateTeam/reducer';

const SelectPlayers = () => {

    const { state, dispatch } = useContext(ManualImportMatchContext);

    const handleChange = (selectedPlayers) => {
        dispatch({
            type: reducerActions.selectPlayer, 
            payload: selectedPlayers
        });
    }

    return (
        <>
            <MatchInfoSummary />
            <FccSection>
                <SelectTeam 
                    playerList={state.playerData} 
                    handleChange={handleChange} 
                    alreadySelectedPlayers={state.selectedPlayers}
                    />
            </FccSection>
        </>
    )
}

export default SelectPlayers;